export default "__VITE_ASSET__k8tOz_Jn__"